/* eslint-disable no-console */
import React, { useState } from 'react';
import CustomFilterGridColumn from './custom-filter-grid-column';
import './custom-filter-wrapper.scss';
import Button from '@atlaskit/button';

export interface filterField {
  iterableValues: Array<{ key: string; value: string }>; // iterableValues shows exact list of filter fields to choose from.
  queryKey: string; // queryKey is one of defined graphql variables.
  filterItem: string; // filterItem identifies whether filter is for Products, Payment Method, Status etc .
}

export interface CustomFilterWrapperProps {
  filterFields: Array<filterField>;
  handleFilterUpdate: (queryFilters: Array<filter>) => void;
}

interface filter {
  key: string;
  value: string;
}
export const CustomFilterWrapper: React.FC<CustomFilterWrapperProps> = ({ filterFields, handleFilterUpdate }) => {
  const [currentFilters, setCurrentFilters] = useState<Array<filter>>([]);
  const [clearSelected, setClearSelected] = useState<boolean>(false);

  const updateQueryFilter = (key: string, value: string) => {
    const filters = currentFilters.filter((item) => item.key !== key);
    if (!currentFilters.find((item) => item.key === key && item.value === value)) {
      filters.push({ key, value });
    }
    setCurrentFilters(filters);
    handleFilterUpdate(filters);
  };

  return (
    <div className="custom-filter-wrapper" data-testId="custom-filter-wrapper">
      {filterFields.map((item: filterField, index: number) => {
        return (
          <CustomFilterGridColumn
            key={index}
            filterField={item.filterItem}
            queryKey={item.queryKey}
            filterableItems={item.iterableValues}
            updateQueryFilter={updateQueryFilter}
            clearSelectedField={clearSelected}
          />
        );
      })}
      {currentFilters.length > 0 && (
        <Button
          appearance="link"
          testId="filter-reset-link"
          onClick={() => {
            setClearSelected(!clearSelected);
            setCurrentFilters([]);
            handleFilterUpdate([]);
          }}
        >
          Clear all filters
        </Button>
      )}
    </div>
  );
};
